import React from "react";
import ConfirmDialog from "../../../../components/ConfirmDialog/ConfirmDialog";

const DeactivateUserDialog = ({
  open,
  onClose,
  onConfirm,
  userName,
  roleName,
  loading,
}) => {
  return (
    <ConfirmDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      heading="Deactivate External User"
      content={
        <>
          Are you sure you want to deactivate{" "}
          <strong>{userName || "this user"}</strong> as{" "}
          <strong>{roleName || "this role"}</strong>? This will revoke their
          access to your organization.
        </>
      }
      buttonText={loading ? "Deactivating..." : "Deactivate"}
      loading={loading}
    />
  );
};

export default DeactivateUserDialog;
